module.exports = __webpack_public_path__ + "static/media/02.51ef9a11.png";